import { Component } from 'react';
import Raven from 'raven-js';
import styled from 'foundations-theming/utils';
import { Image } from 'foundations-components/transitional/components/Image';
import { Link } from 'foundations-components/transitional/components/Link';
import { Modal } from 'foundations-components/transitional/components/Modal';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
// @ts-expect-error not migrated
import WistiaVideoPlayer from 'ui-addon-video-player/components/WistiaVideoPlayer';
import { H2 } from 'foundations-components/transitional/components/H2';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
import { parseUrl } from 'hub-http/helpers/url';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { BREAKPOINTS } from 'foundations-components/transitional/components/Grid';
import { startConfetti } from '../../../utils/confetti';
import TrackAwardModalSharing from './TrackAwardModalSharing';
import { getAwardSharingPath } from '../../../utils/RoutingUtils';

// @ts-expect-error image
import certBackgroundShapeUrl from 'bender-url!../../../../images/blob.svg';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { LANGUAGE_STRINGS } from '../../Languages';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CONFETTI_TIME = 600000;

// @bend-expect trellis-tokenized
const CertificateBackground = styled.div.withConfig({
  displayName: "TrackAwardModal__CertificateBackground",
  componentId: "sc-1cmlazl-0"
})(["background-image:url(", ");background-position:top;background-repeat:no-repeat;background-size:contain;z-index:-1;width:100%;max-width:750px;padding:", ";margin:0;@media (min-width:", "px){padding:", " ", " ", ";margin:-", " ", " -", ";}"], props => props.src, ({
  theme
}) => theme.space['200'], BREAKPOINTS.sm, ({
  theme
}) => theme.space['700'], ({
  theme
}) => theme.space['1500'], ({
  theme
}) => theme.space['1500'], ({
  theme
}) => theme.space['700'], ({
  theme
}) => theme.space['1500'], ({
  theme
}) => theme.space['1500']);
const SharingContainer = styled.div.withConfig({
  displayName: "TrackAwardModal__SharingContainer",
  componentId: "sc-1cmlazl-1"
})(["@media (min-width:", "){margin-bottom:80px;}"], BREAKPOINTS.sm);
function getIsSubheadingReady(showLinkedTrackAwardInfo, track, progressLoading) {
  if (!showLinkedTrackAwardInfo && track && track.get('name')) {
    return true;
  }
  if (showLinkedTrackAwardInfo && !progressLoading) {
    return true;
  }
  return false;
}
class TrackAwardModal extends Component {
  constructor(...args) {
    super(...args);
    this.state = {};
    this.onDownloadCertificate = event => {
      var _this$props$onDownloa, _this$props;
      const navigator = window.navigator;
      if (navigator.msSaveBlob && this.certImageBlobForIE) {
        navigator.msSaveBlob(this.certImageBlobForIE, event.currentTarget.getAttribute('download'));
      }
      (_this$props$onDownloa = (_this$props = this.props).onDownloadCertificate) === null || _this$props$onDownloa === void 0 || _this$props$onDownloa.call(_this$props, event);
    };
    this.onImgLoadError = ({
      currentTarget
    }) => {
      const {
        award
      } = this.props;
      const {
        hasRetriedLoading
      } = this.state;
      const extra = {
        category: currentTarget.dataset.category,
        src: currentTarget.src,
        award,
        visibility: award === null || award === void 0 ? void 0 : award.visibility,
        hasRetriedLoading,
        certificateUrl: award === null || award === void 0 ? void 0 : award.certificate,
        userId: award === null || award === void 0 ? void 0 : award.userId
      };
      this.captureBreadcrumb('onImgLoadError', extra);

      // Always log the error first
      Raven.captureMessage('TrackAwardModal: Certificate image failed to load', {
        level: 'error',
        extra
      });
    };
    this.onLoadCertImage = ({
      currentTarget
    }) => {
      if (!this.state.certObjectUrl) {
        const cnv = document.createElement('canvas');
        cnv.height = currentTarget.naturalHeight;
        cnv.width = currentTarget.naturalWidth;
        const ctx = cnv.getContext('2d');
        if (ctx) {
          ctx.drawImage(currentTarget, 0, 0);
        }
        if (cnv.toBlob) {
          cnv.toBlob(blob => {
            if (blob) {
              this.setCertImageState(blob, currentTarget.src);
            }
          });
        } else {
          // IE fallback
          const canvasWithMsToBlob = cnv;
          if (canvasWithMsToBlob.msToBlob) {
            setTimeout(() => {
              // Delayed to allow canvas.drawImage to fully complete
              this.certImageBlobForIE = canvasWithMsToBlob.msToBlob();
              if (this.certImageBlobForIE) {
                this.setCertImageState(this.certImageBlobForIE, currentTarget.src);
              }
            });
          }
        }
        this.captureBreadcrumb('onLoadCertImage', {
          src: currentTarget.src,
          height: cnv.height,
          width: cnv.width
        });
      }
    };
    this.onTogglePublicVisibility = checked => {
      this.captureBreadcrumb('onTogglePublicVisibility', {
        checked
      });
    };
  }
  componentDidMount() {
    const {
      award,
      onMount
    } = this.props;
    if (new Date().getTime() - award.awardedAt < CONFETTI_TIME) {
      this.cleanupConfetti = startConfetti();
    }
    onMount();
    this.captureBreadcrumb('componentDidMount');
  }
  componentDidUpdate(prevProps) {
    if (prevProps.award !== this.props.award) {
      this.captureBreadcrumb('componentDidUpdate (changed award)', {
        prevAward: prevProps.award
      });
    }
  }
  componentWillUnmount() {
    if (this.state.certObjectUrl) {
      URL.revokeObjectURL(this.state.certObjectUrl);
    }
    if (this.cleanupConfetti) {
      this.cleanupConfetti();
      delete this.cleanupConfetti;
    }
    this.captureBreadcrumb('componentWillUnmount');
  }
  captureBreadcrumb(message, data = {}) {
    const {
      award
    } = this.props;
    Raven.captureBreadcrumb({
      message,
      category: 'TrackAwardModal',
      data: Object.assign({
        award
      }, data)
    });
  }
  setCertImageState(blob, src) {
    this.setState({
      certObjectUrl: URL.createObjectURL(blob),
      certFileName: parseUrl(src).path.replace(/^.*\//, '')
    });
  }

  // for tracks where the cert has been awarded in a different language
  // we show a modified subheading
  renderSubHeading() {
    const {
      award,
      examAttempt,
      linkedTrackId,
      linkedTrackLanguage,
      track,
      progressLoading
    } = this.props;
    const showLinkedTrackAwardInfo = linkedTrackId !== null;
    const correctQuestionCount = examAttempt.score;
    const totalQuestionCount = examAttempt.questionIds && examAttempt.questionIds.length || 0;
    const isSubheadingReady = getIsSubheadingReady(showLinkedTrackAwardInfo, track, progressLoading);
    const scoreText = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.finished.yourScoreWas",
      options: {
        correctQuestionCount,
        totalQuestionCount
      }
    });
    const courseName = track.get('name');
    const language = award.language;
    if (!isSubheadingReady) {
      return /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        marginBlockEnd: "400",
        children: /*#__PURE__*/_jsxs(View, {
          inlineSize: "50%",
          children: [/*#__PURE__*/_jsx(SkeletonText, {}), /*#__PURE__*/_jsx(SkeletonText, {})]
        })
      });
    }

    // show current track exam info
    if (!showLinkedTrackAwardInfo) {
      return /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: 'learningCenter.exams.finished.passedSubheading',
          options: {
            courseName
          }
        }), scoreText]
      });
    }

    // show linked track exam info
    if (linkedTrackLanguage) {
      return /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        paddingInline: "300",
        children: /*#__PURE__*/_jsxs(Text, {
          textAlign: "center",
          typography: "body-125",
          children: [/*#__PURE__*/_jsx(View, {
            marginBlockEnd: "300",
            maxInlineSize: "500px",
            children: /*#__PURE__*/_jsx(FormattedReactMessage, {
              "data-test-id": "track-award-modal-subheading",
              message: "learningCenter.exams.finished.passedInLinkedLanguage",
              options: {
                courseName,
                linkedLanguage: LANGUAGE_STRINGS[linkedTrackLanguage],
                language: LANGUAGE_STRINGS[language]
              }
            })
          }), scoreText]
        })
      });
    }
  }
  render() {
    const {
      award,
      examAttempt,
      firstName,
      onClickShareThis,
      onClose,
      track,
      linkedTrackId
    } = this.props;
    const endOfTrackCtaText = track.get('endOfTrackCtaText');
    const endOfTrackCtaLink = track.get('endOfTrackCtaLink');
    const passVideo = track.getIn(['passVideo', 'url']);
    const hasAwardForLinkedTrack = linkedTrackId !== null;
    const trackId = track.get('id');
    const language = award.language;
    if (!examAttempt) return null;
    return /*#__PURE__*/_jsxs(Modal, {
      "data-test-id": "track-award-modal",
      use: "conversational",
      width: 1250,
      children: [/*#__PURE__*/_jsxs(DialogHeader, {
        children: [/*#__PURE__*/_jsx(H2, {
          "aria-level": 1,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.exams.finished.successHeading",
            options: {
              firstName
            }
          })
        }), /*#__PURE__*/_jsx(DialogCloseButton, {
          onClick: onClose
        })]
      }), /*#__PURE__*/_jsxs(View, {
        minBlockSize: "700px",
        children: [/*#__PURE__*/_jsxs(View, {
          marginBlockEnd: "800",
          textAlign: "center",
          children: [this.renderSubHeading(), !!endOfTrackCtaText && !!endOfTrackCtaLink && /*#__PURE__*/_jsx(Link, {
            href: endOfTrackCtaLink,
            target: "_blank",
            children: /*#__PURE__*/_jsx("h3", {
              children: endOfTrackCtaText
            })
          })]
        }), /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          flexDirection: "column",
          marginInline: "auto",
          minBlockSize: "300px",
          children: [!!award.certificate &&
          /*#__PURE__*/
          // @bend-expect trellis-tokenized
          _jsx(CertificateBackground, {
            src: certBackgroundShapeUrl,
            children: /*#__PURE__*/_jsx(Image, {
              crossOrigin: "anonymous",
              "data-category": "cert",
              onError: this.onImgLoadError,
              onLoad: this.onLoadCertImage,
              responsive: true,
              src: award.certificate
            })
          }), !!passVideo && /*#__PURE__*/_jsx(View, {
            inlineSize: "95%",
            maxInlineSize: "746px",
            padding: "500",
            position: "relative",
            children: /*#__PURE__*/_jsx(WistiaVideoPlayer, {
              videoId: passVideo
            })
          }), /*#__PURE__*/_jsx(SharingContainer, {
            children: /*#__PURE__*/_jsxs(Flex, {
              alignItems: "center",
              flexDirection: "column",
              children: [/*#__PURE__*/_jsx(TrackAwardModalSharing, {
                certFileName: this.state.certFileName,
                certObjectUrl: this.state.certObjectUrl,
                onClickShareThis: onClickShareThis,
                onDownloadCertificate: this.onDownloadCertificate,
                shareThisPath: getAwardSharingPath(trackId)
              }), hasAwardForLinkedTrack && /*#__PURE__*/_jsx(RouterLink, {
                paddingBlockStart: "400",
                to: `/tracks/${trackId}/exam`,
                children: /*#__PURE__*/_jsx(FormattedReactMessage, {
                  message: "learningCenter.exams.finished.linkedExamCTA",
                  options: {
                    language: LANGUAGE_STRINGS[language]
                  }
                })
              })]
            })
          })]
        })]
      })]
    });
  }
}
TrackAwardModal.defaultProps = {
  examAttempt: {
    score: 0
  },
  hasAwardPrivacyToggle: false,
  onClose: () => {},
  onDownloadCertificate: () => {},
  onMount: () => {},
  linkedTrackId: null,
  linkedTrackLanguage: null
};
export default TrackAwardModal;